import React, { ReactElement } from 'react';
import OktaSecuredRoute from '../../auth/OktaSecuredRoute';

const SecuredRoute = ({ children }: { children: ReactElement }) => {
  return <OktaSecuredRoute>{children}</OktaSecuredRoute>;
};

export default SecuredRoute;
